import React, { useState, forwardRef } from 'react';
import ReactDropdown from 'react-dropdown';
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { pushNotification } from "utils/notifications";

const monthOptions = [
    ...Array.from({ length: 12 }, (_, i) => ({ value: i + 1, label: `Tháng ${i + 1}` }))
];
const yearOptions = [
    ...Array.from({ length: 11 }, (_, i) => ({
        value: new Date().getFullYear() + i,
        label: `${new Date().getFullYear() + i}`
    }))
];

export const SearchBarDestop = ({ initialFilters, onApply }) => {
    const [filters, setFilters] = useState(initialFilters);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };
    const handleDateChange = (field) => (date) => {
        setFilters(prev => ({
            ...prev,
            [field]: date,
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear()
        }));
    };
    const handleDropdownChange = (field) => (selectedOption) => {
        const value = selectedOption.value;
        setFilters(prev => ({
            ...prev,
            [field]: value,
            dtFrom: null,
            dtTo: null
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (filters.month < new Date().getMonth() + 1 && filters.year <= new Date().getFullYear()) {
            pushNotification("Không tìm kiếm về thời gian nhỏ hơn hiện tại", "error");
            return;
        }
        onApply(filters);
    };
    const getMinDateForToPicker = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (filters.dtFrom && filters.dtFrom > today) {
            return filters.dtFrom;
        }
        return today;
    };
    return (
        <form onSubmit={handleSubmit}>
            <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3 flex-wrap">
                <div className="input-sm-new" style={{ flex: 1, minWidth: '120px' }}>
                    <label className="font-color-default font-bold">Tên Khách Hàng</label>
                    <input type="text" name="customerName" placeholder="Nhập từ khóa" value={filters.customerName} onChange={handleChange} className="form-control input-sm" />
                </div>
                <div className="input-sm-new" style={{ flex: 1, minWidth: '120px' }}>
                    <label className="font-color-default font-bold">Số Điện Thoại</label>
                    <input type="text" name="phoneNumber" placeholder="Nhập từ khóa" value={filters.phoneNumber} onChange={handleChange} className="form-control input-sm" />
                </div>
                <div className="input-sm-new" style={{ flex: 1, minWidth: '120px' }}>
                    <label className="font-color-default font-bold">CMTND/CCCD</label>
                    <input type="text" name="identifierCode" placeholder="Nhập từ khóa" value={filters.identifierCode} onChange={handleChange} className="form-control input-sm" />
                </div>
                <div className="input-sm-new" style={{ flex: 1, minWidth: '120px' }}>
                    <label className="font-color-default font-bold">Mã Hợp Đồng</label>
                    <input type="text" name="contractCode" placeholder="Nhập từ khóa" value={filters.contractCode} onChange={handleChange} className="form-control input-sm" />
                </div>
                <div className="input-sm-new" style={{ width: '120px' }}>
                    <label className="font-color-default font-bold">Từ ngày</label>
                    <DateTimePicker
                        value={filters.dtFrom}
                        onChange={handleDateChange("dtFrom")}
                        placeholder="Chọn ngày"
                        maxDate={filters.dtTo}
                    />
                </div>
                <div className="input-sm-new" style={{ width: '120px' }}>
                    <label className="font-color-default font-bold">Đến ngày</label>
                    <DateTimePicker
                        value={filters.dtTo}
                        onChange={handleDateChange("dtTo")}
                        placeholder="Chọn ngày"
                        minDate={getMinDateForToPicker()}
                    /> 
                </div>
                <div className="input-sm-new" style={{ minWidth: '100px' }}>
                    <label className="font-color-default font-bold">Tháng</label>
                    <ReactDropdown options={monthOptions}
                        onChange={handleDropdownChange('month')}
                        value={monthOptions.find(option => option.value === filters.month)}
                        placeholder="Chọn tháng"
                        controlClassName="form-control input-sm d-flex" />
                </div>
                <div className="input-sm-new" style={{ minWidth: '100px' }}>
                    <label className="font-color-default font-bold">Năm</label>
                    <ReactDropdown options={yearOptions}
                        onChange={handleDropdownChange('year')}
                        value={yearOptions.find(option => option.value === filters.year)}
                        placeholder="Chọn năm"
                        controlClassName="form-control input-sm d-flex" />
                </div>
                <div>
                    <button type="submit" className="btn btn-info-new" style={{ paddingTop: "8px" }}><i className="la la-search"></i> Tìm kiếm</button>
                </div>
            </div>
        </form>
    );
};